import { render, staticRenderFns } from "./CancellingFunds.vue?vue&type=template&id=45d16afd"
import script from "./CancellingFunds.vue?vue&type=script&lang=js"
export * from "./CancellingFunds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports